import { useContext } from 'react';
import { ShiftContext } from '@/contexts/ShiftContext';

export function useShift() {
    const context = useContext(ShiftContext);
    if (context === undefined) {
        throw new Error('useShift must be used within a ShiftProvider');
    }
    return context;
}
